<template>
    <el-row>
        <el-col>
              <el-table :data="maintenanceData" style="width: 100%" :default-sort="{ prop: 'date', order: 'descending' }">
                  <el-table-column type="index" label="序号">
                  </el-table-column>
                  <el-table-column prop="wbrxm" label="借用人" sortable width="120"  show-overflow-tooltip>
                  </el-table-column>

                  <el-table-column prop="equipment" label="使用器材" sortable >
                  </el-table-column>

                  <el-table-column prop="wz" label="状态"  width="120">
                  </el-table-column>
                  <el-table-column  label="操作" >
                      <template slot-scope="scope">
                          <el-link :underline="false"  style="color: #4095E5;text-decoration: none;" @click="toWbDetail(scope.row)">详情 </el-link>
                      </template>
                  </el-table-column>
              </el-table>
          </el-col>

          <!--分页工具条-->
          <el-col :span="24" class="toolbar" style="margin-top:5px;height: 35px;">
              <el-pagination v-if="maintenanceData.length > 0" @size-change="handleSizeChange"
                  @current-change="handleCurrentChange" :page-sizes="[5]" :page-size="pagesize"
                  layout="total, sizes, prev, pager, next, jumper" :total="total" style="float:right">
              </el-pagination>
          </el-col>
    </el-row>
</template>
<script>
import { getMaintenanceByDeviceId } from '../../../api/api';
export default {
      data() {
          return {
              pagesize:5,
              pageIndex: 1,
              total:4,
              maintenanceData: []
          }
      },
      props: {
          deviceinfo: {
              default: {}
          }
      },
      methods: {
          handleCurrentChange(val) {
              this.pageIndex = val;
          //     //contentdata是所有的数据，是一个大数组。使用.slice()方法可以将大数组切分
          //     //.slice()方法接受两个参数，开始和结束的值
          //     //这样得到的currentdata就是固定只有10个值的数组了，就可以用v-for展示啦
             this.getMaintenance();
          },
          handleSizeChange(val) {
              this.pagesize = val;
             this.getMaintenance();
          },
          getMaintenance(){
              let id=JSON.parse(sessionStorage.getItem("deviceinfoDetail")).id;
              let _params={
                deviceId:id,
                pageIndex:this.pageIndex,
                pageSize:this.pagesize
              }
              getMaintenanceByDeviceId(_params).then(datas=>{
                  let {status,data,message}=datas
                  if(status==200){
                      this.maintenanceData=data.list
                      this.total=data.total
                  }
              })
          },
          toWbDetail(row){
            sessionStorage.setItem("wbData",JSON.stringify(row))
            // debugger
            let userinfo=JSON.parse(localStorage.getItem("user"))
            let userRoles=userinfo.role.menuId
            if(userRoles.indexOf("153")==-1){
                this.$message({message: "你没有权限访问该页面",type: 'warning'});
            }else{
                this.$router.push({
                    path: "/maintenance"
                });
            }
          }

      },
      created() {
        this.getMaintenance();
      }
  }

</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/device/components/BorrowingRecord.vue